import { v4 as uuidV4 } from 'uuid';

import {
  type DerivedEventFilterLegacy,
  type DerivedEventLegacy,
  DerivedEventTypeLegacy,
} from '@verantos-dev/types-cohorts';
import { Instance_eventContext } from '@verantos-dev/util-cohort-builder-typescript-runtime';

import getActualValueFromDSL from './getActualValueFromDSL';
import { getEventName, getEventDateAttributes } from './getDerivedEventFilters';

const getInstanceEvents = (
  event: Instance_eventContext | null,
  dirty?: boolean // set to true to annotate input fields as dirty
) => {
  try {
    const filters = event?.instance_event_criteria()?.instance_event_criterion();
    const eventFilters: DerivedEventFilterLegacy[] = [];
    if (filters) {
      let event = {};
      let position = {};
      let index = {};
      filters.forEach((filter) => {
        if (filter.instance_event_event()) {
          event = {
            id: uuidV4(),
            eventName: {
              id: uuidV4(),
              value: getEventName(filter?.instance_event_event()),
              dirty,
            },
            eventDateAttribute: {
              id: uuidV4(),
              value: getEventDateAttributes(filter.instance_event_event()),
              dirty,
            },
          };
        }
        if (filter.instance_event_position()) {
          const eventPosition = filter.instance_event_position();
          if (eventPosition?.aggregation_qualified()) {
            position = {
              id: uuidV4(),
              value:
                eventPosition?.aggregation_qualified()?.MAX()?.getText() ||
                eventPosition?.aggregation_qualified()?.MIN()?.getText(),
              dirty,
            };
          }
          if (eventPosition?.specific_instance()) {
            position = {
              id: uuidV4(),
              value: eventPosition?.specific_instance()?.INDEX()?.getText() || '',
              dirty,
            };
            index = {
              id: uuidV4(),
              value: eventPosition?.specific_instance()?.INT()?.getText() || '',
              dirty,
            };
          }
        }
      });
      if (Object.keys(index).length > 0) {
        eventFilters.push({
          ...event,
          position,
          index,
        } as DerivedEventFilterLegacy);
      } else {
        eventFilters.push({
          ...event,
          position,
        } as DerivedEventFilterLegacy);
      }
    }

    return {
      id: uuidV4(),
      name: getActualValueFromDSL(event?.INSTANCE_EVENT_NAME()?.getText()) || '',
      type: DerivedEventTypeLegacy.INSTANCE,
      anyOrder: false,
      temporalConstraints: [],
      eventFilters,
      uniquenessFilters: [],
    };
  } catch (error) {
    console.error('Error fetching sequence events', error);
    return {} as DerivedEventLegacy;
  }
};

export default getInstanceEvents;
